/**
 * Estado inicial del formulario F-22 AT 2026 - Régimen 14D3 (Pro PYME)
 *
 * Contiene todos los campos editables con valores por defecto.
 * Los campos calculados se generan en tiempo real por formulas.js.
 * Este estado se asocia a una empresa específica (id_company).
 */

export const createInitialState = () => ({
  // Metadatos
  anioTributario: 2026,
  anioComercial: 2025,
  regimen: '14d3',

  // ===== ANTECEDENTES =====
  antecedentes: {
    // Socios (cargados dinámicamente desde módulo Socios)
    socios: [],

    // Retiros del ejercicio (cargados desde módulo Socios y Dividendos)
    retiros: [],

    // Ingresos del giro
    ventasNoRelacionadasNeto: 0,
    ventasNoRelacionadasNoPercibido: 0,
    ventasNoRelacionadasPercibido: 0,
    ventasRelacionadasProPymeNeto: 0,
    ventasRelacionadasProPymeNoPercibido: 0,
    ventasRelacionadasProPymePercibido: 0,
    ventasRelacionadas14ANeto: 0,
    ventasRelacionadas14ANoPercibido: 0,
    ventasRelacionadas14APercibido: 0,
    cobroFactura2024Neto: 0,
    cobroFactura2024NoPercibido: 0,
    cobroFactura2024Percibido: 0,

    // Otros ingresos
    ingresosVentaComputador: 0,
    creditoBanco: 0,

    // Dividendos percibidos
    dividendo1Percibido: 0,
    dividendo1Factor: 0.369863,
    dividendo1Credito: 0,
    dividendo1Regimen: 'Art. 14 letra A)',
    dividendo2Percibido: 0,
    dividendo2Factor: 0.142857,
    dividendo2Credito: 0,
    dividendo2Regimen: 'Art. 14 letra D) N°3',
    dividendo3Percibido: 0,
    dividendo3Factor: 0.228747,
    dividendo3Credito: 0,
    dividendo3Regimen: 'Art. 14 letra D) N° 3',
    dividendo4Percibido: 0,
    dividendoINR: 0,
    dividendoSTUT: 0,
    totalDividendosPercibido: 0,

    // Egresos
    comprasNeto: 0,
    comprasPagado: 0,
    compraCamionetaNeto: 0,
    compraCamionetaPagado: 0,
    remuneracionesBruto: 0,
    remuneracionesPagado: 0,
    remuneracionesAdeudado: 0,
    honorariosBruto: 0,
    honorariosAdeudado: 0,
    honorariosPagados: 0,
    gastosGenerales: 0,
    arriendos: 0,
    cotizacionesDic2024: 0,
    retencionesIUSCDic2024: 0,
    pagoProveedores2024: 0,
    amortizacionCapital: 0,
    amortizacionInteres: 0,
    pagoInteresesMultas: 0,
    pagoIDPCAT2025: 0,
    ppmHistorico: 0,
    reajustePPMHistorico: 0,

    // CPTS al 31.12.2024
    cptsAl31Dic2024: 0,

    // Parámetros
    valorUF: 39727.96,
    tasaIDPC: 0.125,

    // Remanentes anteriores (del F-22 AT anterior)
    remanentesAnteriores: {
      RAI: 0,
      REX_RAP: 0,
      REX_INR: 0,
      SAC_noSujetoSinDev: 0,
      SAC_noSujetoConDev: 0,
      SAC_sujetoConDev: 0,
      SAC_IPE_sinDev: 0,
      SAC_2016_conDev: 0,
      STUT: 0,
      creditoIDPC2016ConDev: 0,
    },
  },

  // ===== CRÉDITO IPE =====
  creditoIPE: {
    dividendoExtranjeroUSD: 0,
    tipoCambioDolar: 0,
    tasaRetencion: 0.15,
    tasaCorporativo: 0.32,
    perdidasRelacionadas: 0,
    gastosRelacionados: 0,
  },
});
